module.exports = "/assets/data/b1f65baaf074bad026ee63f554f76075-TR20.data.json";